module.exports = {
  "zones": {
    "America/Bogota": ["z", {
      "wallclock": -1739059200000,
      "format": "-05/-04",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -1739041424000,
      "save": 0,
      "rules": "CO"
    }, {
      "wallclock": -2707689600000,
      "format": "BMT",
      "abbrev": "BMT",
      "offset": -17776000,
      "posix": -2707671824000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -17776000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "CO": [{
      "from": 1993,
      "to": 1993,
      "month": 3,
      "day": [7, 4],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1992,
      "to": 1992,
      "month": 4,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};